require('./bootstrap');
require('./components/scanner');
require('./components/mass-checkbox-select');
require('./components/calculate-prices');
require('./components/formula-examples');
require('./components/scanner-input');
